import OverlayPresenceStore from "@utils/OverlayPresenceStore";
import { KzOverlayEventDetail } from "kz-ui-sdk";

import { dispatchAnalyticsEvent } from "./dispatch";
import { EVENTS } from "./events/constants";
import { providersReady } from "./providers";

type QueuedEvent = { eventName: string; metadata: Record<string, unknown> };

let queue: QueuedEvent[] | null = [];
void providersReady.then(() => {
  queue?.forEach(({ eventName, metadata }) => dispatchAnalyticsEvent(eventName, metadata));
  queue = null;
});

function emit(eventName: string, metadata: Record<string, unknown>): void {
  if (queue) {
    queue.push({ eventName, metadata });
    return;
  }
  dispatchAnalyticsEvent(eventName, metadata);
}

// A caller-set overlayId is a stable name; a useId-shaped id (contains ":") falls
// back to the backdrop aria label.
function popupNameFrom(detail: KzOverlayEventDetail): string | null {
  if (!detail.overlayId.includes(":")) return detail.overlayId;
  return detail.label ?? null;
}

OverlayPresenceStore.getInstance().onOpened((detail) => {
  const popupName = popupNameFrom(detail);
  if (popupName) emit(EVENTS.POPUP_SHOWN, { popupName });
});
